export { default as ApiClient } from './ApiClient'
import ApiClient from './ApiClient'

// Create a singleton instance of the API client
const apiClientInstance = new ApiClient()

export const getApiClient = () => apiClientInstance
export { apiClientInstance as apiClient }
